import { getFullMonthNames } from '../../common/utils/dateTime';
import { storeAction } from "./../../store/storeActions.constant";

export const memberProfileConstants = {
    ADMIN_TOOLS: 'Admin Tools',
    IMPERSONATE: 'Impersonate',
    ENABLE_IMPERSONATION: 'Enable Impersonation',
    DISABLE_IMPERSONATION: 'Disable Impersonation',
    PHONE_NUMBER_PREFIX: '+',
    ASTERISK: '*',
    COLON: ':',
    PROFILE_PERCENTAGE: '%',
    AT: 'at',
    REQUIRED: '* Required',
    ADD_PHOTO: 'ADD PHOTO',
    SHARE: 'SHARE',
    BACK_TO: 'Back To',
    BACK: 'BACK',
    PROFESSIONAL_EXPERIENCE: 'Professional Experience',
    MY_YPO_COMMUNITIES: 'My YPO Communities',
    ABOUT_ME: 'About Me',
    MY_CONTACT_INFORMATION: 'My Contact Information',
    YPO_MESSENGER: 'YPO Messenger',
    MESSAGE_ME: 'Message Me Now',
    MY_ACTIVITY: 'My Activity',
    FOLLOW_ME: 'FOLLOW ME',
    PROFESSIONAL_OUTSIDE: 'Professional Roles Outside YPO',
    COMPANY_INVESTMENTS: 'Company Investments',
    YPO_CHAMPION_POSITIONS: 'YPO Champion Positions',
    YPO_AWARDS: 'YPO Awards',
    REASONS_CONNECT_WITH_ME: 'Reasons To Connect With Me',
    BEST_WAYS_CONNECT_WITH_ME: 'Best Ways To Contact Me',
    ATTENDING_UPCOMING_EVENTS: 'Attending These Upcoming Events',
    BUSINESS_EXPERTISE: 'Business Expertise & Interests',
    ACCOMPLISHMENTS: 'Accomplishments',
    CURRENT: 'Current',
    PREVIOUS: 'Previous',
    PAST: 'Past',
    SEE_ALL: 'See all',
    SEE_LESS: 'See less',
    EXTERNAL_BOARD_OF_DIRECTORS: 'External Board of Directors',
    PUBLIC_SERVICE: 'Public Service',
    VOLUNTEER_ROLES: 'Volunteer Roles',
    PUBLIC: 'DFD',
    VOLUNTEER: 'Volunteer',
    DATA_PUBLIC_SERVICE: 'Public Service',
    DATA_EXTERNAL_BOARD_POSITION: 'External Board Position',
    DATA_VOLUNTEER: 'Volunteer',
    MY_FAMILY: 'My Family',
    RELATIONSHIP_STATUS: 'Relationship Status',
    CHILD: 'Child',
    SPOUSE: 'Spouse/Partner',
    MALE: 'Male',
    FEMALE: 'Female',
    SON: 'Son',
    DAUGHTER: 'Daughter',
    MY_PERSONAL_FAMILY_INTERESTS: 'My Personal & Family Interests',
    FIELD_OF_STUDY_IN: 'in',
    ALL_FIELDS_REQUIRED: 'Please complete required fields to continue.',
    CHAPTERS: 'Chapters',
    REGIONS: 'Regions',
    NETWORKS: 'Networks',
    BUSINESS: 'Business',
    HOME: `Home`,
    OTHER: `Other`,
    X_FORMERLY_TWITTER: `X (Formerly Twitter)`,
    WHATSAPP: 'WhatsApp',
    X_FORMERLY_TWITTER:'X (Formerly Twitter)',
    FAMILY: 'Family',
    PERSONAL: 'Personal',
    SOCIAL: 'Social',
    GROUPS: 'Groups',
    COMMUNITIES: 'Communities',
    IMPACT: 'Impact',
    EXPERIENCED: 'Experienced',
    INTERESTED: 'Interested',
    CONNECTED: 'connected',
    ADD_TO_CONNECTIONS: 'add to connections',
    FAVORITE: 'favorite',
    ADD_TO_FAVORITE: 'add to favorite',
    FOLLOWING: 'FOLLOWING',
    FAVORITE: 'favorite',
    ADD_TO_FAVORITE: 'add to favorite',
    CONTACT_ME: 'contact me',
    SINCE: 'since',
    NEW: 'NEW',
    LIFETIME: 'Lifetime',
    MEMBER: 'Member',
    YPO_GOLD: 'YPO Gold',
    PLEASE_DO_NOT_SOLICIT: 'Please Do Not Solicit',
    FORMER_MEMBER: 'FORMER MEMBER',
    ERROR_VCARD: 'Error: Contact card cannot be downloaded',
    YOUR_PROFILE_EFFECTIVENESS_SCORE: 'IMPROVE YOUR PROFILE EFFECTIVENESS SCORE',
    INCREASE_YOUR_PROFILE_SCORE_NOW: 'Increase your profile score now:',
    ALL_COMMUNITIES: 'All Communities',
    ADD_MORE: 'ADD MORE',
    AND_MORE: 'and more',
    NAME: 'Name',
    WEBSITE: 'Website',
    DATE_RECEIVED: 'Date Received',
    DATE_PUBLISHED: 'Date Published',
    DATE_OF_SPEECH: 'Date Of Speech',
    INDUSTRY: 'Industry',
    SUB_INDUSTRY: 'Sub-Industry',
    TOPIC: 'Topic',
    DESCRIPTION: 'Description',
    MONTH: 'Month',
    YEAR: 'Year',
    LOCATION: 'Location',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    TYPE_TO_SEARCH: 'Type to search...',
    SAVED_TO_PROFILE: 'Saved To Profile',
    CERTIFICATION: 'Certification',
    COURSE: 'Course',
    DIALOG_CONFIRMATION_TITLE: 'Are You Sure?',
    DIALOG_CONFIRMATION_DESC: 'Please confirm that you want to remove this information from your profile.',
    FIRST_NAME: 'First Name',
    MIDDLE_NAME: 'Middle Name',
    FAMILY_NAME: 'Family Name',
    LAST_NAME: 'Last Name',
    ADD_MORE_INDUSTRIES: 'Add More Industries',
    WEBSITE_INVALID_ERROR: 'Please enter correct url',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'End date must be greater than start date',
    CONTINUE: 'CONTINUE',
    CANCEL: 'CANCEL',
    GRAND_FATHER_MEMBER: 'Grand Fathered Member',
    REQUIRED_FIELD_WARNING: 'Please complete required fields to continue',
    EMAIL_FIELD_WARNING: 'Email Address is already on file',
    SPOUSE_PARTNER_ACCESS_TYPE: 'Site Access / All Event Sign-Up',
    SPOUSE_ALERT_TITLE: 'New Spouse/Partner?',
    SPOUSE_ALERT_TEXT: 'Is this the creation of a new Spouse/Partner?  If so, please delete this Spouse/Partner first.',
    EMAIL_CONFIRM_EMAIL_DIFFERENT: 'Email and confirm email do not match',
    GRAND_FATHER_MEMBER_TEXT: 'Grandfathered - Chapter Only',
    PLEASE_SELECT_INDUSTRY: 'Select Industry Category',
    PLEASE_SELECT_COUNTRY: 'Select Country',
    URL: 'URL',
    LINKEDIN: 'LinkedIn',
    URL_RULE: 'Please enter the correct URL',
    URL_REQUIRED: 'Please enter the URL',
    COUNTRY_CODE: 'Country Code',
    EMAIL_ADDRESS: 'Email Address',
    EXTENSION: 'Extension',
    VALID_EMAIL_ADDRESS: 'Please enter a unique email address',
    INVALID_EMAIL_ADDR: 'Please enter valid email address',
    PHONE_NUMBER_REQUIRED: 'Please enter the phone number',
    PHONE_NUMBER_ERROR: "Please enter the valid phone number",
    SELECT_INTEREST: "Please select your interests",
    M2MX_NAME: 'M2Mx',
    MY_ASSETS_SUMMARY: 'My Businesses Summary',
    MEMBER_FOLLOW: 'Follow',
    MEMBER_FOLLOWING: 'Following',
    CHAPTER_ADMIN: 'Chapter Administrator',
    CHAPTER_MANAGER: 'Chapter Manager',
    PRESENT: 'Present',
    EMAIL_ALREADY_EXIST: 'Email already exists',
    NO_DATA_AVAILABLE: 'No Data Available',
    CONFIRM: 'confirm',
    PROFILE_NOT_EXISTS_MESSAGE: 'This URL is no longer valid.',
    THREE: 3,
    INVESTMENTS_MIN_COUNT: 3,
    COLUMN_LIMIT: 3,
    MAX_NAME_COUNT_EIGHTY: 80,
    FAMILY_COLUMN_LIMIT: 2,
    MY_FAMILY_COLUMN_LIMIT: 3,
    TRUNCATE_LENGTH: 64,
    TRUNCATE_LENGTH_POPOUT: 160,
    MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH: 50,
    MAX_LENGTH: 255,
    MAX_NAME_LENGTH: 100,
    COUNTRY_CODE_LENGTH: 0,
    PHONE_NUMBER_LENGTH: 3,
    MAXIMUM_LENGTH_FOR_EXTENSION_NUMBER: 40,
    MAX_STREET_LENGTH: 250,
    MAX_ZIP_LENGTH: 20,
    MAX_TITLE_LENGTH: 200,
    MAX_COUNTRY_CODE_LENGTH: 3,
    MAX_PHONE_NUMBER_LENGTH: 20,
    MAX_PHONE_EXTENSION_LENGTH: 40,
    EXCHANGE_TEST: 'Exchange Test',
    EXCHANGE_TEST_ID: 'be5e8ea4-7d4f-de11-9c44-005056921c55',
    YPO_IMAGE_URL: 'https://lh3.googleusercontent.com/a-/AN66SAyhV3b3K0J8SW-3hLhIJfEXdO5HnBuTs5X2iXFnyg=s640-il',
    EMAIL_REGEX: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    emailRules: [
        v => !!v || memberProfileConstants.VALID_EMAIL_ADDRESS,
        v => memberProfileConstants.EMAIL_REGEX.test(v) || memberProfileConstants.INVALID_EMAIL_ADDR,
    ],
    emailRule: [
        v => !v || memberProfileConstants.EMAIL_REGEX.test(v) || memberProfileConstants.INVALID_EMAIL_ADDR,
    ],
    WEBSITE_URL_RULE: [
        v => !v || /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9A-Z]+([-.]{1}[a-z0-9A-Z]+)*\.[a-zA-Z]{2,10}(:[0-9]{1,5})?(\/.*)?$/.test(v) || memberProfileConstants.WEBSITE_INVALID_ERROR,
    ],
    COUNTRY_REQUIRED: [
        v => !!v || 'Please select the country',
    ],

    PROFESSIONAL_EXP: {
        COMPANY: 'Company',
        PRESIDENT_TYPE: 'President Type',
        COMPANY_TYPE: 'Company Type',
        COMPANY_SIZE: 'Company Size',
        SCOPE: 'Scope',
        CURRENT_COMPANY: 'Current company',
        FORMER_COMPANIES: 'Former Companies',
        CURRENT_COMPANIES: 'Current Companies',
        YOUTH_INTERNSHIP: 'This company offers YPO Youth Internships.',
        EDIT_MY_PROFESSIONAL_EXPERIENCE: 'Edit My Professional Experience',
        COMPANY_NAME: 'Company Name',
        WHO_DO_YOU_REPORT_TO: 'Who do you report to?:',
        BUSINESS_TITLE: 'Business Title',
        WEBSITE_ADDR: 'Website Address',
        ISPRIMARY_CHECK: 'Display this company first on my profile',
        ISYOUTHINTERNSHIP: 'This company offers YPO Youth Internships',
        ISWORKINGHERE: 'I currently work here',
        BUSINESS_SCOPE: 'Business Scope',
        COMPANY_ADDR: 'Company Address',
        COUNTRY: 'Country*',
        STREET: 'Street Address*',
        CITY: 'City*',
        STATE: 'State/Province/Region*',
        POSTAL_CODE: 'ZIP/Postal Code*',
        DESCRIPTION: 'Tell us about this company',
        ADDRESS_ADDRESS_TYPE_RULE: [
            v => !!v || 'Please enter the address type',
        ],
        COMPANY_NAME_REQUIRED: [
            v => !!v || 'Please enter the company name',
        ],
        WHO_DO_YOU_REPORT_TO_REQUIRED: [
            v => !!v || 'Please enter Who do you report to',
        ],
        PRESIDENT_TYPE_REQUIRED: [
            v => !!v || 'Please select your president type',
        ],
        COMPANY_TYPE_REQUIRED: [
            v => !!v || 'Please select your company type',
        ],
        COMPANY_SIZE_REQUIRED: [
            v => !!v || 'Please select your company size',
        ],
        BUSINESS_SCOPE_REQUIRED: [
            v => !!v || 'Please select your business scope',
        ],
        MONTH_REQUIRED: [
            v => !!v || 'Please select the month',
        ],
        YEAR_REQUIRED: [
            v => !!v || 'Please select the year',
        ],
        INDUSTRY_CATEGORY_REQUIRED: [
            v => !!v || 'Please select your industry',
        ],
        STREET_REQUIRED: [
            v => !!v || 'Please enter the street',
        ],
        CITY_REQUIRED: [
            v => !!v || 'Please enter the city',
        ],
        STATE_REQUIRED: [
            v => !!v || 'Please select the state',
        ],
        POSTAL_CODE_REQUIRED: [
            v => !!v || 'Please enter the ZIP/Postal',
        ],
    },

    CONTACT_INFORMATION: {
        PRIMARY_EMAIL: 'Primary Email',
        SECONDARY_EMAIL: 'Secondary Email',
        FAX: 'Fax',
        BUSINESS_FAX: 'Business Fax',
        HOME_FAX: 'Home Fax',
        HOME_PHONE: 'Home Phone',
        OTHER_PHONE: 'Other Phone',
        WHATSAPP: 'WhatsApp',
        BUSINESS: 'Business',
        MOBILE: 'Mobile',
        BUSINESS_ADDRESS: 'Business Address',
        HOME_ADDRESS: 'Home Address',
        EXECUTIVE_ASSISTANT: 'Executive Assistant',
        EVENT_PLATFORM_NOTIFICATIONS: 'CC on Event Platform notifications',
        GLOBAL_MARKETING_NOTIFICATIONS: 'CC on Global Marketing notifications',
        EMERGENCY_CONTACT: 'Emergency Contact',
        LINKEDIN_CONTACT: 'LinkedIn',
        DOWNLOAD_CONTACT_INFO: 'Download Contact Info',
        EMAIL: 'Email',
        PHONE_NUMBER: 'Phone Number',
        ADDRESS: 'Address',
        ADDRESS_TYPE: 'Address Type',
        SOCIAL_NETWORKS: 'Social Networks',
        TITLE: 'Edit My Contact Information',
        SUB_TITLE: 'Tell members the best way to reach you.',
        ADDRESS_HELP_TEXT: 'Please share up to two addresses',
        EDIT_EMAIL: 'Edit My Email Address',
        EMAIL_DISPLAY: 'Display On My Profile',
        SEND_EMAIL: 'Send YPO Admin Emails Here',
        EDIT_MY_EMERGENCY_CONTACT: 'Edit My Emergency Contact',
        EMERGENCY_RELATION_TO_YOU: 'Relation to You',
        EMERGENCY_RETYPE_EMAIL_ADDRESS: 'Re-type Email Address',
        EMERGENCY_EMAIL_MATCH_RULE: 'Please enter same email address',
        EDIT_MY_ADDRESS: 'Edit My Address',
        TEXT: ' & Text',
        MAKE_PRIMARY_ADDRESS: 'Make primary address',
        MAKE_VISIBLE_TO_OTHERS: 'Make visible to other members',
        NO_STATES_AVAILABLE: 'Please select Country',
        PRIMARY: 'Primary',
        SECONDARY: 'Other',
        EDIT_MY_PHONE_NUMBER: 'Edit My Phone Number',
        IS_BUSINESS_PRIMARY_NUMBER: 'Business Phone',
        IS_HOME_PRIMARY_NUMBER: 'Home Phone',
        IS_MOBILE_PRIMARY_NUMBER: 'Mobile Phone',
        IS_OTHER_PRIMARY_NUMBER: 'Other Phone',
        IS_WHATSAPP_PRIMARY_NUMBER: 'WhatsApp Phone',
        IS_HOME_FAX_NUMBER: 'Home Fax',
        IS_BUSINESS_FAX_NUMBER: 'Business Fax',
        DISPLAY_ON_MY_PROFILE: 'Display On My Profile',
        MEMBERS_CAN_TEXT_ME_HERE: 'Members Can Text Me Here',
        PRIMARY_NUMBER_FOR_MY_YPO_ACCOUNT: 'Primary Number For My YPO Account',
        EDIT_MY_SOCIAL_NETWORKS: 'Edit My Social Networks',
        EDIT_MY_LINKEDIN_NETWORK: 'Edit My LinkedIn Network',
        SOCIAL_NETWORK_NAME: 'Social Network Name',
        EDIT_MY_LINKEDIN_NETWORK: 'Edit My LinkedIn Network',
        EDIT_MY_EXECUTIVE_ASSISTANT: 'Edit My Executive Assistant',
        FAX_NUMBER: 'Fax Number',
        EXTENSION: 'Extension',
        EXT: 'Ext.',
        PLS_COMPLETE_REQUIRED_FIELDS: 'Please complete required fields to continue.',
        SELECT_PRIMARY_NUMBER: 'Select primary number.',
        EMERGENCY_RELATIONSHIP_RULE: [
            v => !!v || 'Please enter the relationship type',
        ],
        EMERGENCY_NAME_RULE: [
            v => !!v || 'Please enter the name',
        ],
        EMERGENCY_EMAIL_RULE: [
            v => !v || memberProfileConstants.EMAIL_REGEX.test(v) || 'Please enter valid email address',
        ],
        FIRST_NAME_RULE: [
            v => !!v || 'Please enter the first name',
        ],
        LAST_NAME_RULE: [
            v => !!v || 'Please enter the last name',
        ],
        SOCIAL_NETWORK_RULE: [
            v => !!v || 'Please select social network type',
        ],
    },

    ABOUT_ME_SECTION: {
        EDIT_ABOUT_ME: 'Edit About Me',
        MY_BIOGRAPHY: 'My Biography',
        EDIT_MY_FAMILY: 'Edit My Family',
        RELATION_TO_YOU: 'Relation To You',
        GENDER: 'Gender',
        TITLE_PREFIX: 'Title/Prefix',
        FIRST_OR_GIVEN_NAME: 'First/Given Name',
        MIDDLE_NAME: 'Middle Name',
        LAST_OR_FAMILY_NAME: 'Last/Family Name',
        SUFFIX: 'Suffix',
        CONFIRM_EMAIL_ADD: 'Confirm Email Address',
        DATE_OF_BIRTH: 'Date Of Birth',
        SPOUSE_ACCESS: 'Yes, give my spouse/partner access to YPO Connect.',
        SPOUSE_PARTNER_ACCESS: 'Spouse/Partner Access',
        EDIT_MY_FAMILY_INTEREST: 'Edit My Personal & Family Interests',
        EDIT_MY_FAMILY_INTEREST_TEXT:
            'Share your personal and family interests - the things you enjoy or want to know more about - so members and their spouses/partners can find you.',
        EDIT_MY_FAMILY_INTEREST_TEXT1: 'What types of interests do you and/or your family share?',
        EDIT_MY_FAMILY_INTEREST_TEXT2: 'Get specific. Select one or more examples to display on your profile.',
        INTEREST: 'Interest',
        PERSONAL_FAMILY: 'Personal_Family',
        SELECT_INTERESTS: 'Please select your interests',
        EDIT_MY_BIOGRAPHY: 'Edit My Biography',
        RELATION_TO_YOU_ERROR: [
            v => !!v || 'Please enter Relation To You',
        ],
        GENDER_ERROR: [
            v => !!v || 'Please enter Gender',
        ],
        FIRST_OR_GIVEN_NAME_ERROR: [
            v => !!v || 'Please enter First/Given Name',
        ],
        LAST_OR_FAMILY_NAME_ERROR: [
            v => !!v || 'Please enter Last/Family Name',
        ],
    },

    TRAINING_CERTIFICATION: {
        TRAINING: 'Training & Certification',
        COURSES_TAKEN: 'Courses Taken',
        CERTIFICATIONS: 'Certifications',
        EDIT_TRAINING_CERTIFICATION: 'Edit Training & Certification',
        EDIT_CERTIFICATIONS: 'Edit Certifications',
        EDIT_COURSES_TAKEN: 'Edit Courses Taken',
        PLEASE_ENTER_CERTIFICATION_NAME: [
            v => !!v || 'Please enter your certification name',
        ],
        PLEASE_ENTER_COURSE_NAME: [
            v => !!v || 'Please enter your course name',
        ],
    },

    DEFAULT_EDIT_TEXT: {
        PROFESSIONAL_EXP:
            'Help members understand your professional experience and connect with you based on your work history.',
        ROLES: 'Share your participation in external boards, public service and/or volunteer roles.',
        COMPANY_INVESTMENTS:
            'Interested in business investments? Share companies and industries in which you’re currently invested.',
        NETWORKS_LINK: 'Find business, family, personal and impact networks',
        NETWORKS_TEXT:
            'dedicated to robust education and idea exchange. Make instant, confidential connections to other YPO members around the world.',
        GROUPS_TEXT: 'Do you have interests not currently represented by YPO’s Networks?',
        GROUPS_LINK: 'Find member-initiated online groups.',
        ABOUT_ME:
            'Round out your impressive professional profile by sharing more about yourself and your family. The more you share, the better your chances of making valuable YPO connections.',
        MEMBER_TO_MEMBER_EXCHANGE: 'Member To Member Exchange',
        MY_ACTIVITY: 'Add a post in the box above to share news and opinions with your YPO followers.',
        BUSINESS_EXPERTISE:
            'Increase your networking opportunities by describing your expertise and interests in key business categories.',
        MY_CONTACT_INFORMATION: 'Tell members the best ways to reach you.',
        EDUCATION: 'Connect with new colleagues and former alumni.',
        ACCOMPLISHMENTS:
            'Share some of the accomplishments and experiences that have led you to join our global leadership community.',
        TRAINING_CERTIFICATION:
            'Give members a reason to reach out to you. Tell us about your certifications and any courses you may have taken',
        SHARE_SOMETHING: 'Share something with your YPO followers...',
        M2MX_QUOTE: 'Answers you need, when you need them.',
        M2MX_UPDATE: 'M2Mx confidentially connects members and spouses/partners to share experience with business and personal issues, health resources and medical support.',
        M2MX_SHARE: 'Sharing your experience could be life-changing for fellow YPO members.',
        M2MX_UPDATE_PROFILE: 'Update M2MX profile',
        M2MX_UPDATE_PROFILE_URL: '#/m2mxprofile',
        MANAGE_FOLLOWERS: 'Manage my followers',
        MY_BIOGRAPHY:
            'Help members get to know you by sharing your professional biography. Feel free to round out your experience by adding personal information that members should know.',
        MY_PERSONAL_FAMILY_INTERESTS:
            'Share your personal and family interests — the things you enjoy or want to know more about — so members and their spouses/partners can find you.',
        MY_FAMILY:
            'Brag about your spouse/partner and children. If you want to give your spouse/partner access to YPO Connect, this is where to do it.',
    },

    EDUCATION: {
        EDUCATION: 'Education',
        EDIT_EDUCATION: 'Edit My Education',
        GRADUATE_SCHOOL: 'Graduate School',
        HIGH_SCHOOL: 'High School',
        SCHOOL_TYPE: 'School Type',
        SCHOOL_NAME: 'School Name',
        DEGREE_TYPE: 'Degree Type',
        FIELD_OF_STUDY: 'Field of Study',
        GRADUATION_YEAR: 'Graduation year',
        PREFER: 'I Prefer Not to Say',
        EDUCATION_MIN_COUNT: 0,
        EDUCATION_MAX_COUNT: 5,
        EDUCATION_MAX_COUNT_ADD_MORE: 4,
        PLEASE_ENTER_SCHOOL_NAME: [
            v => !!v || 'Please enter your school name',
        ],
        PLEASE_ENTER_SCHOOL_TYPE: [
            v => !!v || 'Please select school type',
        ],
    },

    ACCOMPLISHMENT: {
        EDIT_ACCOMPLISHMENT: 'Edit Accomplishments',
        EXTRN_HONORS_AWARDS: 'External Honors and Awards',
        DATA_EXTRN_HONORS_AWARDS: 'External Honor/Award',
        DATA_PUBLICATIONS: 'Publication',
        PUBLICATIONS: 'Publications',
        DATA_SPEAKING_EVENTS: 'Speaking Event',
        SPEAKING_EVENTS: 'Speaking Events',
        DATA_VIDEOS: 'Video',
        VIDEOS: 'Videos',
        PATENTS: 'Patents',
        DATA_PATENTS: 'Patent',
        EDIT: 'Edit',
        ADD: 'Add',
        ACCOMPLISHMENT_NAME_RULE: [
            v => !!v || 'Please enter name',
        ],
    },

    PROFILE_PHOTO: {
        PROFILE_PHOTO_EDIT: 'Edit Your Profile Photo',
        UPLOAD_PHOTO_DESC: 'Drag a photo or upload a photo from your device',
        CHOOSE_ANOTHER_PHOTO: 'CHOOSE ANOTHER PHOTO',
        ROTATE: 'Rotate',
    },

    SUMMARY: {
        EDIT_PROFILE_SUMMARY: 'Edit Intro',
        PREFERRED_NAME: 'Preferred Name',
        PREFIX: 'Prefix',
        FIRST_NAME: 'First (Given) Name',
        SUFFIX: 'Suffix',
        BIRTHDAY: 'Birthday (Private)',
        AGE: 'Age (Private)',
        FIRSTNAME_RULE: [
            v => !!v || 'Please enter the first name',
        ],
        LASTNAME_RULE: [
            v => !!v || 'Please enter the last name',
        ],
    },

    COMPANY_INVESTMENT: {
        EDIT_COMPANY_INVESTMENT: 'Edit Company Investments',
        PLEASE_ENTER_COMPANY_NAME: 'Please enter your company name',
        TYPE: 'Company Investment',
    },

    BUSINESS_EXPERTISE_INTEREST: {
        EDIT_BUSINESS_EXPERTISE: 'Edit Business Expertise & Interests',
        BUSINESS_DESC:
            'Ensure you appear in member searches by sharing your experience and/or interest in key business topics.',
        EXPERTISE: 'Expertise',
        INTEREST: 'Interest',
    },

    PROFESSIONAL_ROLES: {
        EDIT: 'Edit Professional Roles Outside YPO',
        VOLUNTEER_HERE: 'I currently volunteer here',
        POSITION: 'I currently hold this position',
        BOARD_MEMBER: 'I am a current board member',
        EDIT_EXTERNAL_BOARDS: 'Edit External Boards',
        EDIT_PUBLIC_SERVICES: 'Edit Public Services',
        EDIT_VOLUNTEER_ROLES: 'Edit Volunteer Roles',
        EXTERNAL_BOARDS: 'External Boards',
        PUBLIC_SERVICES: 'Public Services',
        VOLUNTEER_ROLES: 'Volunteer Roles',
    },
};

export const memberProfileWizards = () => {
    return [
        {
            key: 'Add Your Photo',
            mainSubtitle: 'Drag & Drop or Click Here',
            shortSubtitle: 'to upload your photo',
            icon: 'fas fa-user-circle file-upload__placeholder',
            dialog: 'uploadPhotoDialog',
            isEmpty: true,
        },
        {
            key: 'Add Your Email',
            mainSubtitle: 'Help Members Contact You',
            shortSubtitle: 'Add your email addresses now',
            icon: 'fas fa-envelope file-upload__placeholder',
            dialog: 'openEmailEditDialog',
            isEmpty: true,
        },
        {
            key: 'Add Your Phone Number',
            mainSubtitle: 'Help Members Contact You',
            shortSubtitle: 'Add your phone number now',
            icon: 'fas fa-phone file-upload__placeholder',
            dialog: 'phoneNumbersDialog',
            isEmpty: true,
        },
        {
            key: 'Add Your Address',
            mainSubtitle: 'Help Members Find You',
            shortSubtitle: 'Add a visible address to your profile',
            icon: 'fas fa-map-marker-alt file-upload__placeholder',
            dialog: 'openAddressDialog',
            isEmpty: true,
        },
        {
            key: 'Tell Us About Your Education',
            mainSubtitle: 'Share Your Background',
            shortSubtitle: 'Add schools you have attended',
            icon: 'fas fa-graduation-cap file-upload__placeholder',
            dialog: 'educationDialog',
            isEmpty: true,
        },
        {
            key: 'Add Your Business Expertise & Interests',
            mainSubtitle: 'You Are An Expert In Your Field',
            shortSubtitle: 'Share at least 1 area of expertise and interests',
            icon: 'fas fa-chart-bar file-upload__placeholder',
            dialog: 'businessDialog',
            isEmpty: true,
        },
        {
            key: 'Add Your Business Expertise & Interests',
            mainSubtitle: 'Add Your Business Expertise & Interests',
            shortSubtitle: 'Share at least 1 area of expertise and interests',
            icon: 'fas fa-chart-bar file-upload__placeholder',
            dialog: 'businessDialog',
            isEmpty: true,
        },
        {
            key: 'Tell Us Your Title',
            mainSubtitle: 'Complete The Company Profile Displayed Below',
            shortSubtitle: 'Tell members your current business title',
            icon: 'fas fa-building file-upload__placeholder',
            dialog: 'professionalExperienceAddDialog',
            isEmpty: true,
        },
        {
            key: 'Add Your Company Address',
            mainSubtitle: 'Complete The Company Profile Displayed Below',
            shortSubtitle: "Tell members your current company's address",
            icon: 'fas fa-building file-upload__placeholder',
            dialog: 'professionalExperienceAddDialog',
            isEmpty: true,
        },
        {
            key: 'Add Your Current Business Size',
            mainSubtitle: 'Complete The Company Profile Displayed Below',
            shortSubtitle: 'Tell members the size of your current business',
            icon: 'fas fa-building file-upload__placeholder',
            dialog: 'professionalExperienceAddDialog',
            isEmpty: true,
        },
        {
            key: 'Add President Type',
            mainSubtitle: 'Complete The Company Profile Displayed Below',
            shortSubtitle: 'Select which best describes your president type',
            icon: 'fas fa-building file-upload__placeholder',
            dialog: 'professionalExperienceAddDialog',
            isEmpty: true,
        },
        {
            key: 'Add Business Scope',
            mainSubtitle: 'Complete The Company Profile Displayed Below',
            shortSubtitle: 'Select which best describes your business scope',
            icon: 'fas fa-building file-upload__placeholder',
            dialog: 'professionalExperienceAddDialog',
            isEmpty: true,
        },
        {
            key: 'Add Company Type',
            mainSubtitle: 'Complete The Company Profile Displayed Below',
            shortSubtitle: 'Select which best describes your company type',
            dialog: 'professionalExperienceAddDialog',
            icon: 'fas fa-building file-upload__placeholder',
            isEmpty: true,
        },
        {
            key: 'Add Company Industry',
            mainSubtitle: 'Complete The Company Profile Displayed Below',
            shortSubtitle: "Select which best describes your company's industry",
            icon: 'fas fa-building file-upload__placeholder',
            dialog: 'professionalExperienceAddDialog',
            isEmpty: true,
        },
        {
            key: 'Tell Us About Yourself',
            mainSubtitle: 'Help Members Get To Know You',
            shortSubtitle: 'Add your professional overview',
            icon: 'fas fa-user file-upload__placeholder',
            dialog: 'isBiographyDialogEdit',
            isEmpty: true,
        },
        {
            key: 'Add Your Social Presence',
            mainSubtitle: 'Round Out Your Professional Profile',
            shortSubtitle: 'Share your social networks with YPO members',
            icon: 'fas fa-user file-upload__placeholder',
            dialog: 'socialNetworkDialog',
            isEmpty: true,
        },
    ];
};

export const reasonsToConnectConstants = {
    Industries: 'Our common industries:',
    Company_Size: 'We lead companies of similar sizes:',
    Business_Expertise: 'Our expertise in:',
    Business_Interests: 'Mutual interest in:',
    Business_Expertise_To_Interests: 'I want to know more about your experience in:',
    Business_Interests_To_Expertise: 'You want to know more about my experience in:',
    Communities_Name: 'Our common communities:',
};

const communityDirectoryFilters = {
    Networks: {
        filterKey: 'CommunityType',
        filterValue: 'Network',
        isTypeAhead: false,
        label: 'Network',
        ribbonGroupName: 'Community Type',
        subFilters: [],
    },
    Groups: {
        filterKey: 'CommunityType',
        filterValue: 'Group',
        isTypeAhead: false,
        label: 'Group',
        ribbonGroupName: 'Community Type',
        subFilters: [],
    },
};

export const navigateToCommunityDirectory = (type) => {
    return {
        path: '/communityDirectoryPage',
        query: {
            filters: '',
            navigatedFromId: '',
            communitySearchText: '',
            communityFilters: JSON.stringify({
                CommunityType: [communityDirectoryFilters[type]],
                CommunityFocus: [],
                EligibilityRequirements: [],
            }),
        },
    };
};

export const DateDifference = (startDate, endDate) => {
    const startDay = new Date(startDate);
    const endDay = endDate ? new Date(endDate) : new Date();
    const age = {};
    const syear = startDay.getFullYear();
    const smonth = startDay.getMonth() + 1;
    const sday = startDay.getDate();
    let eyear = endDay.getFullYear();
    let emonth = endDay.getMonth() + 1;
    const eday = endDay.getDate();
    const months = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (eday < sday) {
        age.days = (eday - sday) + months[startDay.getMonth()];
        emonth -= 1;
    } else {
        age.days = eday - sday;
    }
    if (emonth < smonth) {
        age.months = (emonth - smonth) + 12;
        eyear -= 1;
    } else {
        age.months = emonth - smonth;
    }
    age.years = eyear - syear;
    return age;
};

export const displayAge = (birthdate) => {
    let ageStatement = '';
    if (birthdate) {
        const age = DateDifference(birthdate);
        if (age.years > 0) {
            ageStatement = `${age.years} year${age.years === 1 ? '' : 's'} old`;
        } else if (age.months > 0) {
            ageStatement = `${age.months} month${age.months === 1 ? '' : 's'} old`;
        } else if (age.days > 0) {
            ageStatement = `${age.days} day${age.days === 1 ? '' : 's'} old`;
        }
    }
    return ageStatement;
};

export const assetSummaryConstants = {
    ASSET_SUMMARY_TITLE: 'My Businesses Summary',
    MANAGE_ASSETS: 'Manage My Businesses',
    VIEW_ASSETS: 'View My Businesses',
    DOWNLOAD_ASSETS: 'Download My Businesses',
    SELECT_ALL: 'Select All',
    NEW_ASSETS: 'New Business',
    BULK_UPLOAD: 'Bulk Add',
    DUPLICATE_ASSETS: 'Duplicate Businesses ',
    NO_EXISTING_ASSETS_TEXT1: 'No businesses added yet.',
    NO_EXISTING_ASSETS_TEXT2: 'Click + New Business button to create your first business',
    NO_EXISTING_ASSETS_TEXT3: 'or the Bulk Add to add multiple businesses at once',
    NAME_OF_RESTAURANT: 'Name of Restaurant / Hotel',
    BRAND_OF_HOTEL: 'Brand of Restaurant / Hotel',
    STREET_ADDRESS1: 'Street Address',
    STREET_ADDRESS2: 'Street Address Line 2',
    CITY: 'City / Location',
    STATE: 'State / Province',
    ZIP_CODE: 'Zip Code',
    COUNTRY: 'Country',
    REGION: 'Region',
    RELATIONSHIP_ASSET: 'Relationship to Business',
    ACCOMODATION: 'Accommodation Type',
    ESTABLISHMENT: 'Establishment Type',
    CUISINE: 'Cuisine',
    DESTINATION_RESTAURANT: 'Destination Restaurant',
    OTHER_CATEGORY: 'Other Category',
    WEBSITE: 'Website URL',
    DISCOUNT_CODE: 'Discount Code',
    TELEPHONE: 'Telephone',
    TELEPHONE_COUNTRY_CODE: 'Telephone Country Code',
    ADDITIONAL_INFORMATION: 'Manager / Point of Contact for Reservations / Additional Information',
    MANAGER_TELEPHONE: 'Manager / Point of Contact Telephone Number',
    MANAGER_TELEPHONE_COUNTRY_CODE: 'Manager / Point of Contact Telephone Country Code',
    MANAGER_EMAIL: 'Manager / Point of Contact Email Address',
    DOLLAR: '$',
    HOTEL_CLASS: 'Hotel Class',
    OWNER_OPERATOR: 'YPO Investor/Owner/Operator',
    SAVE_SUBMIT: 'SAVE AND SUBMIT',
    DELETE_ASSETS_TITLE: 'Delete Selected Businesses',
    DELETE_ASSET_CONFIRMATION: 'Are you sure you want to delete the selected businesses ?',
    OPERATOR_INFO: 'Must first fill required fields before adding Investor/Owner/Operator',
    DINING: 'Dining',
    ACCOMMODATION: 'Accommodation',
    DENY: 'DENY',
    APPROVE: 'APPROVE',
    ASSETNAME_REQUIRED: 'Business name is required',
    STREET_ADDRESS_REQUIRED: 'Street address is required',
    CITY_REQUIRED: 'City is required',
    STATE_REQUIRED: 'State is required',
    ZIP_REQUIRED: 'Zip is required',
    REGION_REQUIRED: 'Please select the region',
    ESTABLISHMENT_TYPE_REQUIRED: 'Please select the establishment type',
    CUISINE_REQUIRED: 'Please select the cuisine',
    ACCOMODATION_TYPE_REQUIRED: 'Please select the accommodation type',
    RELATIONSHIP_TO_ASSET_REQUIRED: 'Please select the relationship to business',
    COUNTRY_CODE_REQUIRED: 'Country code is required',
    ADD_OWNER: 'Add Investor/Owner/Operator',
    EDIT_OWNER: 'Edit Investor/Owner/Operator',
    SEARCH_PROFILE: 'Search for a profile',
    OK: 'OK',
    YES: 'YES',
    NO: 'NO',
    SUBMISSION_COMPLETE_TEXT: 'Your Business has been submitted for review. You will receive an email once it has been reviewed by an administrator.',
    SUBMISSION_COMPLETE_TITLE: 'Submission complete',
    REVIEW_PENDING_WARNING: 'This business has been submitted for review. It cannot be edited until the review is completed.',
    ASSET_SAVE: 'The Business has been saved successfully.',
    ASSET_SAVE_TITLE: 'Business saved',
    ASSET_ALREADY_EXIST_RESP: 'Asset already exists do you want to affiliate.',
    ASSET_ALREADY_EXIST_RESP2: 'Asset already exists.',
    ASSET_ALREADY_EXIST_TITLE: 'Business exists',
    ASSET_ALREADY_EXIST_TEXT: 'A business already exists with the same name, address, city and country. Do you wish to associate yourself to this business?',
    ASSET_ALREADY_EXIST_TEXT2: 'A business already exists with the same name, address, city and country.',
    OWNER_RELATION_ASSET: 'Relationship to Business',
    ASSET_OWNER_DELETE_TEXT: 'Are you sure you want to remove this additional Investor/owner/operator from the business?',
    ASSET_OWNER_DELETE_TITLE: 'Investor/owner/operator delete',
    ASSET_OWNER_ALREADY_EXIST: 'User already associated to this business. Please select a different user.',
    ASSET_OWNER_EXIST: 'User exists',
    DENIED_REASON: 'Denied Reason:',
    ASSET_CONFIRM_ADDRESS: 'Please select one of the following addresses to continue',
    STAR_RATING: 'Hotel Star Rating',
    SUBMITTED_BY: 'SUBMITTED BY',
    ASSET_DENY_SUCESS_TITLE: 'Denied!',
    ASSET_DENY_SUCESS_TEXT: 'Denial completed and the requestor has been notified.',
    ASSET_APPROVE_SUCCESS_TITLE: 'Approved!',
    ASSET_APPROVE_SUCCESS_TEXT: 'The new business has been approved and the requestor has been notified.',
    DENIED_CONFIRMATION_TITLE: 'Please enter a reason for denial',
    CONFIRM_AND_DENY: 'CONFIRM AND DENY',
    DENIED_REASON_TITLE: 'Denial Reason',
    NONE_OF_ABOVE: 'None of the above. Use the address I entered.',
    PHONE_NUMBER_PREFIX: '+',
    TELEPHONE_ERROR: "Please enter valid phone number",
    UNITED_STATES: 'United States',
    CANADA: 'Canada',
    US: 'us',
    CA: 'ca',
    BULK_UPLOAD_FALLBACK_URL: 'https://ypodfilestoragetest.blob.core.windows.net',
    BULK_UPLOAD_FRAGMENT: '/businessbulkaddfiles/template/Businesses-Bulk Add Template.xlsx',
    BULK_ADD_MESSAGE_PART: 'Thank you for your interest! To add multiple businesses at once, you are welcome to contact <a href="mailto:concierge@ypo.org" style="text-decoration:none">concierge@ypo.org</a> and we will be happy to assist or click Get Started below to start uploading your Businesses through our custom template. </br><b> &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;-The Hospitality Network</b>',
    GET_STARTED: 'GET STARTED',
    BULK_ADD_MANAGE_BUSINESSES: 'Manage My Businesses - Bulk Add',
    BULK_UPLOAD_STEP1: 'Step 1 : Download Bulk Add Template ',
    BULK_UPLOAD_STEP2: 'Step 2 : Add Business Details to template </br>New Businesses you add will be added as new Businesses to your profile. Modifications to existing Businesses should be made directly in your profile in the Manage My Businesses section',
    BULK_UPLOAD_STEP3: 'Step 3 : Save file and click',
    BULK_UPLOAD_STEP4: 'Step 4 : Locate file and click Open or Select',
    BULK_UPLOAD_STEP5: 'Step 5 : Status of upload will display. Successful Businesses are now added to your profile',
    UPLOAD_WARNING: 'Please upload a valid document.',
    INVALID_DOCUMENT: 'Invalid document',
    UPLOAD_SUCCESS_MESSAGE: 'Please note that files are processed in the order in which they are received. The Records that are processed correctly will be submitted for review. If the file contains an error (i.e. missing required fields), an email with the details will be sent to you once the file has been completely processed.',
    UPLOAD_SUCCESS_TITLE: 'Upload submitted successfully!',
    ADDRESS_LIMIT: 250,
    CITY_LIMIT: 80,
    ZIP_LIMIT: 20,
    MAX_COUNTRY_CODE_LENGTH: 3,
    FIELDS: ['name', 'formatted_phone_number', 'geometry', 'address_component', 'adr_address', 'formatted_address', 'photo', 'website'],
    COLUMN_HEADERS: [
        {
            text: 'BUSINESS NAME', align: 'left', sortable: true, value: 'name',
        },
        {
            text: 'STREET ADDRESS', align: 'left', sortable: false, value: 'address1',
        },
        {
            text: 'CITY/LOCATION', align: 'left', sortable: false, value: 'city',
        },
        {
            text: 'COUNTRY', align: 'left', sortable: false, value: 'country',
        },
        {
            text: 'REGION', align: 'left', sortable: false, value: 'region',
        },
        {
            text: 'STATUS', align: 'left', sortable: true, value: 'assetStatus',
        },
    ],
    relationshipToAsset: [
        {
            text: 'Investor',
            disabled: false,
        }, {
            text: 'Operator',
            disabled: false,
        }, {
            text: 'Owner',
            disabled: false,
        }],
    establishmentTypes: [
        'Accommodation',
        'Dining',
    ],
    regions: [
        'Africa',
        'Asia',
        'Caribbean',
        'Central America',
        'Europe',
        'North America',
        'Oceania',
        'South America',
    ],
    accommodationTypes: [
        'Bed & Breakfast',
        'Boutique',
        'Business',
        'Cruise',
        'Leisure',
        'Resort',
    ],
    cuisineTypes: [
        'American',
        'Bakery',
        'Barbecue',
        'Brasserie/Bistro',
        'Brazilian',
        'Café/Pub',
        'Casual Dining',
        'Destination Restaurant',
        'Ethnic',
        'Family Style',
        'Fast Food',
        'Fine Dining',
        'International',
        'Italian',
        'Mediterranean',
        'Mexican',
        'Other',
        'Seafood',
        'Steakhouse',
        'Wine Bar',
    ],
    destinationRestaurant: [
        {
            name: 'No',
            value: false,
        },
        {
            name: 'Yes',
            value: true,
        },
    ],
    priceRange: [
        '$',
        '$$',
        '$$$',
        '$$$$',
    ],
    hotelClass: [
        'Super Economy',
        'Economy',
        'Midscale',
        'Upscale',
        'Luxury',
    ],
    assetNameRule: [
        v => !!v || assetSummaryConstants.ASSETNAME_REQUIRED,
    ],
    streetAddressRule: [
        v => !!v || assetSummaryConstants.STREET_ADDRESS_REQUIRED,
    ],
    cityRule: [
        v => !!v || assetSummaryConstants.CITY_REQUIRED,
    ],
    stateRule: [
        v => !!v || assetSummaryConstants.STATE_REQUIRED,
    ],
    zipRule: [
        v => !!v || assetSummaryConstants.ZIP_REQUIRED,
    ],
    regionRule: [
        v => !!v || assetSummaryConstants.REGION_REQUIRED,
    ],
    establishmentRule: [
        v => !!v || assetSummaryConstants.ESTABLISHMENT_TYPE_REQUIRED,
    ],
    cuisineRule: [
        v => !!v || assetSummaryConstants.CUISINE_REQUIRED,
    ],
    accommodationRule: [
        v => !!v || assetSummaryConstants.ACCOMODATION_TYPE_REQUIRED,
    ],
    relationshipToAssetRules: [
        v => v.length > 0 || assetSummaryConstants.RELATIONSHIP_TO_ASSET_REQUIRED,
    ],
    websiteUrlRule: [
        // eslint-disable-next-line no-useless-escape
        v => !v || /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(v) || memberProfileConstants.WEBSITE_INVALID_ERROR,
    ],
    telephoneRule: [
        v => !v || /^[+]?(-|1\s|1|\d{1,4}-|\d{1,4}\s|)?((\(\d{1,4}\))|\d{1,9})((-|\s|\.)?(\d{2,9}))+(( x| ext)\d{1,5}){0,1}?$/i.test(v) || 'Please enter valid phone number',
    ],
    emailRule: [
        v => !v || memberProfileConstants.EMAIL_REGEX.test(v) || memberProfileConstants.INVALID_EMAIL_ADDR,
    ],
    countryCodeRule: [
        v => !!v || assetSummaryConstants.COUNTRY_CODE_REQUIRED,
    ],
};

export const pendingAssetsConstants = {
    COLUMN_HEADERS: [
        {
            text: 'BUSINESS NAME', align: 'left', sortable: true, value: 'name',
        },
        {
            text: 'STREET ADDRESS', align: 'left', sortable: false, value: 'address1',
        },
        {
            text: 'CITY/LOCATION', align: 'left', sortable: false, value: 'city',
        },
        {
            text: 'COUNTRY', align: 'left', sortable: false, value: 'country',
        },
        {
            text: 'REGION', align: 'left', sortable: false, value: 'region',
        },
    ],
    NO_PENDING_ASSETS: 'There are no businesses pending for approval.',
    ONE_PENDING_ASSET: 'There is 1 business pending for approval.',
};

export const jsonClone = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};

export const onAssetRelationChange = (value, options) => {
    if (value.length === 0) {
        options.forEach((option) => {
            option.disabled = false;
        });
    } else {
        const selected = value.map(x => x.text || x);
        if (selected.includes('None')) {
            options.forEach((option) => {
                option.disabled = option.text !== 'None';
            });
        } else {
            options.forEach((option) => {
                option.disabled = option.text === 'None';
            });
        }
    }
};

export const compareStartAndEndYears = (data) => {
    const months = getFullMonthNames();
    let invalidDate = false;
    if (data.endYear) {
        if (data.startYear > data.endYear) {
            invalidDate = true;
        }
        if (data.startYear === data.endYear) {
            if (months.indexOf(data.startMonth) > months.indexOf(data.endMonth)) {
                invalidDate = true;
            }
        }
    }
    return invalidDate;
};

export const noSubIndustry = (subIndustry, industryCategory) => {
    return (subIndustry && subIndustry.length === 0 && industryCategory) ? memberProfileConstants.NO_DATA_AVAILABLE : memberProfileConstants.PLEASE_SELECT_INDUSTRY;
};

export const filterResults = (results, search) => {
    if (results && results.length > 0 && !!search) {
        return results.filter((item) => {
            return item.toLowerCase().indexOf(search.toLowerCase()) > -1;
        }).slice(0, 100);
    }
    return [];
};

export const TrainingandCertActions = {
    searchExternalConnection: `memberProfile/${storeAction.searchExternalConnection}`,
    updateTrainingAndCertification: `memberProfile/${storeAction.updateTrainingAndCertification}`,
    saveTrainingAndCertification: `memberProfile/${storeAction.saveTrainingAndCertification}`,
    deleteTrainingAndCertification: `memberProfile/${storeAction.deleteTrainingAndCertification}`,
};
